import { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";

export const searchAssets = async (options: AxiosRequestConfig) => {
  return await axiosInstance.get("/utils/assets", options);
};
